import { useTranslation } from "react-i18next";
import styles from "./RatingBadge.module.scss";

interface RatingBadgeProps {
  voteAverage?: number;
  imdbRating?: number | null;
  kinopoiskRating?: number | null;
  variant?: "card" | "details" | "overlay";
}

const RatingBadge = ({
  voteAverage,
  imdbRating,
  kinopoiskRating,
  variant = "card",
}: RatingBadgeProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const isKP = lang === "ru" || lang === "uk";
  const externalRating = isKP ? kinopoiskRating : imdbRating;
  const externalLabel = isKP ? "КП" : "IMDb";

  return (
    <div className={`${styles.wrapper} ${styles[variant]}`}>
      {voteAverage && (
        <div className={styles.badge}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={variant === "details" ? 14 : 12}
            height={variant === "details" ? 14 : 12}
            viewBox="0 0 12 12"
            fill="none"
          >
            <g clipPath="url(#rb-a)">
              <path
                fill="#00AAAA"
                d="m6 7.984 2.124 1.189-.475-2.387 1.787-1.652-2.417-.287L6 2.637v5.347ZM6 9.13l-3.526 1.974.787-3.964L.294 4.396l4.013-.476L6 .25l1.693 3.67 4.014.476L8.739 7.14l.788 3.964L6 9.13Z"
              />
            </g>
            <defs>
              <clipPath id="rb-a">
                <path fill="#fff" d="M0 0h12v12H0z" />
              </clipPath>
            </defs>
          </svg>
          <span className={styles.value}>{voteAverage?.toFixed(1)}</span>
        </div>
      )}
      {externalRating && (
        <div className={styles.externalBadge}>
          <span className={styles.label}>{externalLabel}</span>
          <span className={styles.externalValue}>{externalRating.toFixed(1)}</span>
        </div>
      )}
    </div>
  );
};

export default RatingBadge;
